import React from 'react';
import { RequestTaskProps } from './RequestTask.props';
import FRContentDescription from '../FRContentDescription/FRContentDescription';
import FRContentTitle from '../FRContentTitle/FRContentTitle';
import RequestContentListOfTasks from '../RequestContentListOfTasks/RequestContentListOfTasks';

const RequestTask = ({
  isDocumentRequest = false,
  title,
  description,
  tasks,
  companyId,
  setUpdateTaskList,
  isInitialSetup,
  primaryInformationRequestId,
  currentPageData,
  isCompanyTemplate,
}: RequestTaskProps) => (
  <>
    <FRContentTitle>{title}</FRContentTitle>
    <FRContentDescription>{description}</FRContentDescription>
    <RequestContentListOfTasks
      isDocumentRequest={isDocumentRequest}
      tasks={tasks}
      companyId={companyId ?? null}
      setUpdateTaskList={setUpdateTaskList}
      isInitialSetup={isInitialSetup}
      primaryInformationRequestId={primaryInformationRequestId}
      currentPageData={currentPageData}
      isCompanyTemplate={isCompanyTemplate}
    />
  </>
);

export default RequestTask;
